// (() => {
//   const root = document.querySelector('[data-lookbook]');
//   if (!root) return;

//   const modal = root.querySelector('[data-lb-modal]');
//   const dataEl = root.querySelector('[data-lb-data]');
//   const imageWrap = root.querySelector('[data-lb-image]');
//   const creditsWrap = root.querySelector('[data-lb-credits]');
//   const openBtns = root.querySelectorAll('[data-lb-open]');
//   const closeBtns = root.querySelectorAll('[data-lb-close]');

//   let currentIndex = 0;
//   const prevBtn = root.querySelector('[data-lb-prev]');
//   const nextBtn = root.querySelector('[data-lb-next]');

//   const data = dataEl ? JSON.parse(dataEl.textContent) : [];

//   // =========================
//   // Body scroll lock (iOS対応)
//   // =========================
//   let scrollY = 0;

//   const lockBodyScroll = () => {
//     // すでに開いてる時に二重ロックしない
//     if (document.documentElement.classList.contains('lb-modal-open')) return;

//     scrollY = window.scrollY || window.pageYOffset || 0;

//     document.documentElement.classList.add('lb-modal-open');
//     document.body.classList.add('lb-modal-open');

//     // iOSで位置が上に飛ばないように固定
//     document.body.style.top = `-${scrollY}px`;
//   };

//   const unlockBodyScroll = () => {
//     document.documentElement.classList.remove('lb-modal-open');
//     document.body.classList.remove('lb-modal-open');

//     document.body.style.top = '';
//     window.scrollTo(0, scrollY);
//   };

//   // =========================


//   const escapeHtml = (s) => {
//     if (typeof s !== 'string') return '';
//     return s
//       .replaceAll('&', '&amp;')
//       .replaceAll('<', '&lt;')
//       .replaceAll('>', '&gt;')
//       .replaceAll('"', '&quot;')
//       .replaceAll("'", '&#39;');
//   };

//   const renderImage = (url) => {
//     if (!imageWrap) return;
//     if (!url) {
//       imageWrap.innerHTML = '';
//       return;
//     }
//     imageWrap.innerHTML = `<img class="lb-modal__img" src="${escapeHtml(url)}" alt="">`;
//   };

//   const renderCredits = (credits) => {
//     if (!creditsWrap) return;

//     const rows = Array.isArray(credits) ? credits : [];
//     const filtered = rows.filter((c) => {
//       const t = (c && c.title) ? String(c.title).trim() : '';
//       const s = (c && c.sku) ? String(c.sku).trim() : '';
//       const p = (c && c.price) ? String(c.price).trim() : '';
//       return t || s || p;
//     });

//     if (filtered.length === 0) {
//       creditsWrap.innerHTML = '';
//       return;
//     }

//     creditsWrap.innerHTML = filtered.map((c) => {
//       const title = c.title ? String(c.title) : '';
//       const sku = c.sku ? String(c.sku) : '';
//       const price = c.price ? String(c.price) : '';
//       const url = c.url ? String(c.url) : '';

//       const titleHtml = url
//         ? `<a href="${escapeHtml(url)}">${escapeHtml(title)}</a>`
//         : `${escapeHtml(title)}`;

//       return `
//         <p class="lb-credit">
//           <span class="lb-credit__item">${titleHtml}</span>
//           <span class="lb-credit__sku">${escapeHtml(sku)}</span>
//           <span class="lb-credit__price">${escapeHtml(price)}</span>
//         </p>
//       `;
//     }).join('');
//   };

//   const openModal = (index) => {
//     const item = data[index];
//     if (!item) return;

//     currentIndex = index;

//     renderImage(item.image);
//     renderCredits(item.credits);

//     modal.hidden = false;
//     modal.setAttribute('aria-hidden', 'false');

//     // 背面スクロールを止める（ここが追加）
//     lockBodyScroll();

//     // クレジットだけスクロールさせたい時：開くたび先頭に戻す（任意）
//     if (creditsWrap) creditsWrap.scrollTop = 0;
//   };

//   const closeModal = () => {
//     modal.hidden = true;
//     modal.setAttribute('aria-hidden', 'true');

//     if (imageWrap) imageWrap.innerHTML = '';
//     if (creditsWrap) creditsWrap.innerHTML = '';

//     // 背面スクロールを元に戻す（ここが追加）
//     unlockBodyScroll();
//   };

//   const goPrev = () => {
//     if (!data.length) return;
//     const nextIndex = (currentIndex - 1 + data.length) % data.length;
//     openModal(nextIndex);
//   };

//   const goNext = () => {
//     if (!data.length) return;
//     const nextIndex = (currentIndex + 1) % data.length;
//     openModal(nextIndex);
//   };

//   if (prevBtn) prevBtn.addEventListener('click', goPrev);
//   if (nextBtn) nextBtn.addEventListener('click', goNext);

//   openBtns.forEach((btn) => {
//     btn.addEventListener('click', () => {
//       const index = Number(btn.getAttribute('data-lb-open'));
//       openModal(index);
//     });
//   });

//   closeBtns.forEach((btn) => {
//     btn.addEventListener('click', closeModal);
//   });

//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape' && !modal.hidden) closeModal();
//   });

//   document.addEventListener('keydown', (e) => {
//     if (modal.hidden) return;
//     if (e.key === 'ArrowLeft') goPrev();
//     if (e.key === 'ArrowRight') goNext();
//   });
// })();

(() => {
  const root = document.querySelector('[data-lookbook]');
  if (!root) return;

  const modal = root.querySelector('[data-lb-modal]');
  const dataEl = root.querySelector('[data-lb-data]');
  const imageWrap = root.querySelector('[data-lb-image]');
  const creditsWrap = root.querySelector('[data-lb-credits]');
  const openBtns = Array.from(root.querySelectorAll('[data-lb-open]'));
  const closeBtns = root.querySelectorAll('[data-lb-close]');

  let currentIndex = 0;
  const prevBtn = root.querySelector('[data-lb-prev]');
  const nextBtn = root.querySelector('[data-lb-next]');

  const data = dataEl ? JSON.parse(dataEl.textContent) : [];

  let scrollY = 0;

  const lockBodyScroll = () => {
    if (document.documentElement.classList.contains('lb-modal-open')) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('lb-modal-open');
    document.body.classList.add('lb-modal-open');
    document.body.style.top = `-${scrollY}px`;
  };

  const unlockBodyScroll = () => {
    document.documentElement.classList.remove('lb-modal-open');
    document.body.classList.remove('lb-modal-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  };

  const escapeHtml = (s) => {
    if (typeof s !== 'string') return '';
    return s
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  };

  const getSourceImageByIndex = (index) => {
    const btn = openBtns[index];
    return btn ? btn.querySelector('.lb__img') : null;
  };

  const renderImage = (sourceImage) => {
    if (!imageWrap) return;

    if (!sourceImage) {
      imageWrap.innerHTML = '';
      return;
    }

    const src = sourceImage.currentSrc || sourceImage.src || '';
    const alt = sourceImage.alt || '';

    imageWrap.innerHTML = `<img class="lb-modal__img" src="${escapeHtml(src)}" alt="${escapeHtml(alt)}">`;
  };

  const renderCredits = (credits) => {
    if (!creditsWrap) return;

    const rows = Array.isArray(credits) ? credits : [];
    const filtered = rows.filter((c) => {
      const t = (c && c.title) ? String(c.title).trim() : '';
      const s = (c && c.sku) ? String(c.sku).trim() : '';
      const p = (c && c.price) ? String(c.price).trim() : '';
      return t || s || p;
    });

    if (filtered.length === 0) {
      creditsWrap.innerHTML = '';
      return;
    }

    creditsWrap.innerHTML = filtered.map((c) => {
      const title = c.title ? String(c.title) : '';
      const sku = c.sku ? String(c.sku) : '';
      const price = c.price ? String(c.price) : '';
      const url = c.url ? String(c.url) : '';

      const titleHtml = url
        ? `<a href="${escapeHtml(url)}">${escapeHtml(title)}</a>`
        : `${escapeHtml(title)}`;

      return `
        <p class="lb-credit">
          <span class="lb-credit__item">${titleHtml}</span>
          <span class="lb-credit__sku">${escapeHtml(sku)}</span>
          <span class="lb-credit__price">${escapeHtml(price)}</span>
        </p>
      `;
    }).join('');
  };

  const openModal = (index) => {
    const item = data[index];
    if (!item) return;

    currentIndex = index;

    const sourceImage = getSourceImageByIndex(index);
    renderImage(sourceImage);
    renderCredits(item.credits);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();

    if (creditsWrap) creditsWrap.scrollTop = 0;
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    if (imageWrap) imageWrap.innerHTML = '';
    if (creditsWrap) creditsWrap.innerHTML = '';

    unlockBodyScroll();
  };

  const goPrev = () => {
    if (!data.length) return;
    openModal((currentIndex - 1 + data.length) % data.length);
  };

  const goNext = () => {
    if (!data.length) return;
    openModal((currentIndex + 1) % data.length);
  };

  if (prevBtn) prevBtn.addEventListener('click', goPrev);
  if (nextBtn) nextBtn.addEventListener('click', goNext);

  openBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const index = Number(btn.getAttribute('data-lb-open'));
      openModal(index);
    });
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'ArrowLeft') goPrev();
    if (e.key === 'ArrowRight') goNext();
  });
})();